export const SET_COMPANY_DETAILS = "SET_COMPANY_DETAILS";
export const SET_COMPANIES = "SET_COMPANIES";
export const RESET_COMPANIES = "RESET_COMPANIES";
export const SET_SPECIFIC_COMPANY = "SET_SPECIFIC_COMPANY";
export const RESET_SPECIFIC_COMPANY = "RESET_SPECIFIC_COMPANY";

